import { Image } from '@chakra-ui/react';
import VideoPlayer from '@/modules/content/common/VideoPlayer';
import MediaSkeleton from '@/modules/content/loop/parts/MediaSkeleton';
import { readDetails } from '@/modules/content/loop/model/contentDetails';
import { TContent } from '@/types/Content.types';

type Props = {
  content: TContent;
  isActive: boolean;
  onRatioDetected?: (ratio: number) => void;
  onPlayStateChange?: (isPlaying: boolean) => void;
  onProgress?: (currentTimeSeconds: number, durationSeconds: number) => void;
};

// The media surface of a reel. Only the focused item mounts a player — one video at a
// time, and neighbours never buffer in the background.
const VideoFrame = ({ content, isActive, onRatioDetected, onPlayStateChange, onProgress }: Props) => {
  const details = readDetails(content);
  const poster = content.effectiveThumbnailUrl ?? content.thumbnailUrl;

  if (!isActive) {
    return poster ? (
      <Image src={poster} alt="" width="100%" height="100%" objectFit="cover" />
    ) : (
      <MediaSkeleton />
    );
  }

  return (
    <VideoPlayer
      source={details.source === 'youtube' ? 'youtube' : 'mux'}
      youtubeVideoId={details.youtube?.videoId}
      muxStatus={details.mux?.status}
      muxPlaybackId={details.mux?.playbackId}
      posterUrl={content.effectiveThumbnailUrl || details.mux?.thumbnailUrl}
      title={content.title}
      // The frame has already committed to a shape, so the player fills it and letterboxes
      // internally rather than imposing a second aspect ratio on top.
      fillContainer
      onRatioDetected={onRatioDetected}
      onPlayStateChange={onPlayStateChange}
      onProgress={onProgress}
    />
  );
};

export default VideoFrame;
